/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetConsentResponse } from '../models/ApiResponseGetConsentResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ConsentControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 특정 서비스 동의여부 조회
   * 특정 서비스에 대한 동의여부 조회합니다.
   * @returns ApiResponseGetConsentResponse OK
   * @throws ApiError
   */
  public getConsentService({
    vin,
    consentType,
  }: {
    vin: string,
    consentType: 'GPS',
  }): CancelablePromise<ApiResponseGetConsentResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/consent/',
      query: {
        'vin': vin,
        'consentType': consentType,
      },
    });
  }
  /**
   * 특정 서비스 동의여부 조회
   * 특정 서비스에 대한 동의여부 조회합니다.
   * @returns ApiResponseGetConsentResponse OK
   * @throws ApiError
   */
  public getConsentService1({
    vin,
    consentType,
  }: {
    vin: string,
    consentType: 'GPS',
  }): CancelablePromise<ApiResponseGetConsentResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/consent',
      query: {
        'vin': vin,
        'consentType': consentType,
      },
    });
  }
}
